(function () {
  var explorers = document.querySelectorAll('[data-hds-explorer]');

  if (!explorers.length) {
    return;
  }

  const DESIGN_REASON_LABELS = {
      "texture-contrast": "Contrasting textures add visual interest.",
      "form-contrast": "Different plant forms create a stronger composition.",
      "layering": "Works well in a complementary garden layer.",
      "color-echo": "Repeats foliage color for visual harmony.",
      "variegation-echo": "Repeats variegated foliage."
  };

  explorers.forEach(function (root) {
    var dataScript = root.querySelector('[data-hds-data]');
    var designCompanionsScript = root.querySelector('[data-hds-design-companions-url]');
    var goalsEl = root.querySelector('[data-hds-goals]');
    var conceptGrid = root.querySelector('[data-hds-concepts]');
    var activeConceptEl = root.querySelector('[data-hds-active-concept]');
    var plantGrid = root.querySelector('[data-hds-plants]');
    var relatedEl = root.querySelector('[data-hds-related]');
    var similarEl = root.querySelector('[data-hds-similar]');
    var companionsEl = root.querySelector('[data-hds-design-companions]');
    var articlesIntroEl = root.querySelector('[data-hds-articles-intro]');
    var articlesEl = root.querySelector('[data-hds-articles]');

    if (!designCompanionsScript || !dataScript || !conceptGrid || !activeConceptEl || !plantGrid || !relatedEl || !similarEl || !goalsEl) {
      return;
    }

    async function loadDesignCompanions(root) {
      var designCompanionsScript = root.querySelector(
        "[data-hds-design-companions-url]"
      );
      const designCompanionsUrl = JSON.parse(designCompanionsScript.textContent);
      const designCompanions = await fetch(designCompanionsUrl).then((res) => {
        if (!res.ok) throw new Error("Could not load design companions");
        return res.json();
      });
      return designCompanions;
    }
    
    var data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (error) {
      root.classList.add('hds-explorer--error');
      return;
    }

    //use async results to set scoped var
    loadDesignCompanions(root).then(function (loadedDesignCompanions) {
      designCompanions = loadedDesignCompanions;
      renderDesignCompanions();
    }).catch(function (error) {
      console.warn(error);
    });

    var concepts = Array.isArray(data.concepts) ? data.concepts : [];
    var plants = Array.isArray(data.plants) ? data.plants : [];
    var articles = Array.isArray(data.articles) ? data.articles : [];
    var goals = Array.isArray(data.goals) ? data.goals : [];
    var conceptsById = indexById(concepts);
    var plantsById = indexById(plants);
    var articlesById = indexById(articles);
    var activeGoalId = data.defaultGoalId || 'just-explore';
    var activeConceptId = conceptsById[data.defaultConceptId] ? data.defaultConceptId : concepts[0] && concepts[0].id;
    var selectedPlantId = null;
    var designCompanions = null;

    render();

    function indexById(items) {
      return items.reduce(function (map, item) {
        if (item && item.id) {
          map[item.id] = item;
        }

        return map;
      }, {});
    }

    function escapeText(value) {
      var span = document.createElement('span');
      span.textContent = value || '';
      return span.innerHTML;
    }

    function getVisibleConcepts() {
      var activeGoal = goals.find(function (goal) {
        return goal.id === activeGoalId;
      });

      if (!activeGoal || !activeGoal.conceptIds || !activeGoal.conceptIds.length) {
        return concepts;
      }

      return activeGoal.conceptIds.map(function (id) {
        return conceptsById[id];
      }).filter(Boolean);
    }

    function getPlants(ids) {
      return (ids || []).map(function (id) {
        return plantsById[id];
      }).filter(Boolean);
    }

    function getArticles(ids) {
      return (ids || []).map(function (id) {
        return articlesById[id];
      }).filter(Boolean);
    }

    function selectGoal(goalId) {
      var goal = goals.find(function (item) {
        return item.id === goalId;
      });

      if (!goal) {
        return;
      }

      activeGoalId = goalId;

      var visibleConcepts = getVisibleConcepts();
      if (visibleConcepts.length) {
        activeConceptId = visibleConcepts[0].id;
        selectedPlantId = null;
        articleSource = 'concept';
      }

      render();
    }

    function selectConcept(conceptId, shouldFocus) {
      if (!conceptsById[conceptId]) {
        return;
      }

      activeConceptId = conceptId;
      selectedPlantId = null;
      render();

      if (shouldFocus) {
        activeConceptEl.focus({ preventScroll: true });
        activeConceptEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function selectPlant(plantId) {
      if (!plantsById[plantId]) {
        return;
      }

      selectedPlantId = plantId;
      renderPlants();
      renderSimilarPlants();
      renderDesignCompanions();
      renderArticles();
    }

    function render() {
      renderGoals();
      renderConcepts();
      renderActiveConcept();
      renderPlants();
      renderRelatedConcepts();
      renderSimilarPlants();
      renderDesignCompanions();
      renderArticles();
    }

    function renderGoals() {
      goalsEl.innerHTML = goals.map(function (goal) {
        var isActive = goal.id === activeGoalId;

        return [
          '<button class="hds-explorer__goal-button" type="button" data-hds-goal-id="' + escapeText(goal.id) + '" aria-pressed="' + isActive + '">',
          escapeText(goal.title),
          '</button>'
        ].join('');
      }).join('');

      goalsEl.querySelectorAll('[data-hds-goal-id]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectGoal(button.getAttribute('data-hds-goal-id'));
        });
      });
    }

    function renderConcepts() {
      var visibleConcepts = getVisibleConcepts();
      conceptGrid.innerHTML = visibleConcepts.map(function (concept) {
        var isActive = concept.id === activeConceptId;

        return [
          '<button class="hds-explorer__concept-card" type="button" data-hds-concept-id="' + escapeText(concept.id) + '" aria-pressed="' + isActive + '">',
          '<span class="hds-explorer__image-wrap hds-explorer__image-wrap--icon">',
          '<img src="' + escapeText(concept.image) + '" alt="" loading="lazy">',
          '</span>',
          '<span class="hds-explorer__card-title">' + escapeText(concept.title) + '</span>',
          '<span class="hds-explorer__card-copy">' + escapeText(concept.description) + '</span>',
          '</button>'
        ].join('');
      }).join('');

      conceptGrid.querySelectorAll('[data-hds-concept-id]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectConcept(button.getAttribute('data-hds-concept-id'), true);
        });
      });
    }

    function renderActiveConcept() {
      var concept = conceptsById[activeConceptId];

      if (!concept) {
        activeConceptEl.innerHTML = '';
        return;
      }

      activeConceptEl.innerHTML = [
        '<div>',
        '<h3>' + escapeText(concept.title) + '</h3>',
        '<p>' + escapeText(concept.description) + '</p>',
        '</div>'
      ].join('');
    }

    function renderPlants() {
      var concept = conceptsById[activeConceptId];
      var conceptPlants = concept ? getPlants(concept.plantIds) : [];

      if (!selectedPlantId && conceptPlants.length) {
        selectedPlantId = conceptPlants[0].id;
      }

      plantGrid.innerHTML = conceptPlants.map(function (plant) {
        var isSelected = plant.id === selectedPlantId;

        return [
          '<article class="hds-explorer__plant-card' + (isSelected ? ' is-selected' : '') + '" data-hds-plant-id="' + escapeText(plant.id) + '">',
          '<button class="hds-explorer__plant-select" type="button" aria-pressed="' + isSelected + '">',
          '<span class="hds-explorer__image-wrap">',
          '<img src="' + escapeText(plant.image) + '" alt="' + escapeText(plant.title) + '" loading="lazy">',
          '</span>',
          '<span class="hds-explorer__card-title">' + escapeText(plant.title) + '</span>',
          '<span class="hds-explorer__card-copy">' + escapeText(plant.summary) + '</span>',
          '</button>',
          plant.url ? '<a class="hds-explorer__view-link" href="' + escapeText(plant.url) + '">View plant <span aria-hidden="true">→</span></a>' : '',
          '</article>'
        ].join('');
      }).join('');

      plantGrid.querySelectorAll('[data-hds-plant-id]').forEach(function (card) {
        card.querySelector('button').addEventListener('click', function () {
          selectPlant(card.getAttribute('data-hds-plant-id'));
        });
      });
    }

    function renderRelatedConcepts() {
      var concept = conceptsById[activeConceptId];
      var relatedConcepts = concept ? (concept.relatedConceptIds || []).map(function (id) {
        return conceptsById[id];
      }).filter(Boolean) : [];

      relatedEl.innerHTML = relatedConcepts.map(function (related) {
        return [
          '<button class="hds-explorer__related-item" type="button" data-hds-related-id="' + escapeText(related.id) + '">',
          '<span class="hds-explorer__related-media"><img src="' + escapeText(related.image) + '" alt="" loading="lazy"></span>',
          '<span>',
          '<span class="hds-explorer__related-title">' + escapeText(related.title) + '</span>',
          '<span class="hds-explorer__related-copy">' + escapeText(related.description) + '</span>',
          '</span>',
          '<span class="hds-explorer__related-arrow" aria-hidden="true">→</span>',
          '</button>'
        ].join('');
      }).join('');

      relatedEl.querySelectorAll('[data-hds-related-id]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectConcept(button.getAttribute('data-hds-related-id'), true);
        });
      });
    }

    function renderSimilarPlants() {
      var selectedPlant = plantsById[selectedPlantId];
      var concept = conceptsById[activeConceptId];
      var similarPlants = selectedPlant ? getPlants(selectedPlant.similarPlantIds) : [];

      if (!similarPlants.length && concept) {
        similarPlants = getPlants(concept.plantIds).filter(function (plant) {
          return plant.id !== selectedPlantId;
        }).slice(0, 4);
      }

      similarEl.innerHTML = similarPlants.map(function (plant) {
        var content = [
          '<span class="hds-explorer__similar-image"><img src="' + escapeText(plant.image) + '" alt="' + escapeText(plant.title) + '" loading="lazy"></span>',
          '<span class="hds-explorer__similar-title">' + escapeText(plant.title) + '</span>',
          '<span class="hds-explorer__similar-copy">' + escapeText(plant.summary) + '</span>'
        ].join('');

        return plant.url
          ? '<a class="hds-explorer__similar-card" href="' + escapeText(plant.url) + '">' + content + '</a>'
          : '<span class="hds-explorer__similar-card">' + content + '</span>';
      }).join('');
    }

    function renderDesignCompanions() {
      if (!companionsEl) {
        return;
      }

      var selectedPlant = plantsById[selectedPlantId];

      if (!selectedPlant || !designCompanions) {
        companionsEl.innerHTML = '';
        return;
      }

      var companionItems = designCompanions[selectedPlant.id]
        ? designCompanions[selectedPlant.id].companions
        : [];

      companionsEl.innerHTML = companionItems.map(function (item) {
        var plant = plantsById[item.id];

        if (!plant) {
          return '';
        }

        var reasonItemsHtml = (item.reasons || []).map(function (reason) {
          var label = DESIGN_REASON_LABELS[reason];

          return label
            ? '<li class="hds-explorer__companion-reason">' + escapeText(label) + '</li>'
            : '';
        }).join('');

var reasonHtml = reasonItemsHtml
  ? '<ul class="hds-explorer__companion-reasons">' + reasonItemsHtml + '</ul>'
  : '';

        var content = [
          '<span class="hds-explorer__similar-image"><img src="' + escapeText(plant.image) + '" alt="' + escapeText(plant.title) + '" loading="lazy"></span>',
          '<span class="hds-explorer__similar-title">' + escapeText(plant.title) + '</span>',
          '<span class="hds-explorer__similar-copy">' + escapeText(plant.summary) + '</span>',
          reasonHtml
        ].join('');

        return plant.url
          ? '<a class="hds-explorer__similar-card" href="' + escapeText(plant.url) + '">' + content + '</a>'
          : '<span class="hds-explorer__similar-card">' + content + '</span>';
      }).join('');
    }
    
    function renderArticles() {
      var concept = conceptsById[activeConceptId];
      var selectedPlant = plantsById[selectedPlantId];
      var articleList = [];
      var introText = 'Articles connected to ' + (concept ? concept.title : 'the current concept') + '.';

      if (selectedPlant && selectedPlant.articleIds && selectedPlant.articleIds.length) {
        articleList = getArticles(selectedPlant.articleIds);
        introText = 'Articles connected to ' + selectedPlant.title + ' and the current concept.';
      }
      
      if (!articleList.length && concept) {
        articleList = getArticles(concept.articleIds);
      }
      
      articlesIntroEl.textContent = introText;

      articlesEl.innerHTML = articleList.map(function (article) {
        return [
          '<a class="hds-explorer__article-card" href="' + escapeText(article.url) + '" target="_blank" rel="noopener noreferrer">',
          '<span class="hds-explorer__article-image"><img src="' + escapeText(article.image) + '" alt="' + escapeText(article.title) + '" loading="lazy"></span>',
          '<span class="hds-explorer__article-content">',
          '<span class="hds-explorer__article-label">Article</span>',
          '<span class="hds-explorer__article-title">' + escapeText(article.title) + '</span>',
          '<span class="hds-explorer__article-copy">' + escapeText(article.summary) + '</span>',
          '<span class="hds-explorer__article-link">Read article <span aria-hidden="true">→</span></span>',
          '</span>',
          '</a>'
        ].join('');
      }).join('');
    }
  });
})();
